import lottie from "lottie-web";
import { createPortal } from "react-dom";
import data from "../../assets/xloading.json";
import { useEffect, useRef } from "react";

export default function EasyLoading(prop: { isShow: boolean }) {
  const lottieRef = useRef(null);

  useEffect(() => {
    if (prop.isShow) {
      lottie.destroy();
      lottie.loadAnimation({
        container: lottieRef.current!,
        loop: true,
        autoplay: true,
        renderer: "svg",
        animationData: data,
      });
    }
  }, [prop.isShow]);

  if (!prop.isShow) return null;

  return createPortal(
    <div className={`fixed top-0 w-full h-full`}>
      <div className={`bg-#1F25332E flex flex-items-center flex-justify-center w-full h-full`}>
        <div ref={lottieRef} className="w-12 h-12"></div>
      </div>
    </div>,
    document.body
  );
}
